import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconRadar = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 32,
	height: 32,
	fill: "none",
	viewBox: "0 0 32 32",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		clipPath: "url(#a)",
		children: [
			/* @__PURE__ */ _jsx("path", { d: "M16 14V1a15 15 0 0 1 14 9.6l-12.15 4.7" }),
			/* @__PURE__ */ _jsx("path", { d: "M16 18a2 2 0 1 0 0-4 2 2 0 0 0 0 4" }),
			/* @__PURE__ */ _jsx("path", { d: "M24 16.6a8 8 0 1 1-12-7.55m18.95 5.7Q31 15.4 31 16A15 15 0 1 1 12 1.55" })
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "a",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M0 0h32v32H0z"
		})
	}) })]
});
export default SvgIconRadar;
